import { render, staticRenderFns } from "./gift_list.vue?vue&type=template&id=71aa8c2b&scoped=true"
import script from "./gift_list.vue?vue&type=script&lang=js"
export * from "./gift_list.vue?vue&type=script&lang=js"
import style0 from "./gift_list.vue?vue&type=style&index=0&id=71aa8c2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa8c2b",
  null
  
)

export default component.exports